import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import "@fontsource/kanit";  
import "@fontsource/kanit/100.css";     
import "@fontsource/kanit/500.css"; 
import "@fontsource/kanit/700.css"; 
import { createPinia } from 'pinia';
import 'font-awesome/css/font-awesome.min.css'

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
appInstance.use(createPinia()); 
